import { Skeleton } from '@mui/material';
import {
    MailOutline as MailIcon,
    WhatsApp as WhatsAppIcon,
    ErrorOutline as ErrorIcon,
} from '@mui/icons-material';
import {
    ContainerCards,
    OverviewCard,
    OverviewLabel,
    NotDeliveredCard,
} from '../Logs.styled';

const LogsCardsSkeleton = () => (
    <ContainerCards>
        <OverviewCard>
            <div>
                <OverviewLabel>
                    <MailIcon sx={{ fontSize: 14, opacity: 0.5, color: '#1976d2' }} />
                    E-mail
                </OverviewLabel>
                <Skeleton variant="text" width={60} height={36} />
            </div>
        </OverviewCard>
        <OverviewCard>
            <div>
                <OverviewLabel>
                    <WhatsAppIcon sx={{ fontSize: 14, opacity: 0.5, color: '#25D366' }} />
                    WhatsApp
                </OverviewLabel>
                <Skeleton variant="text" width={60} height={36} />
            </div>
        </OverviewCard>
        <NotDeliveredCard>
            <OverviewLabel sx={{ mb: '6px' }}>
                <ErrorIcon sx={{ fontSize: 14, color: '#c62828' }} />
                Não entregues
            </OverviewLabel>
            <Skeleton variant="rounded" height={16} sx={{ mb: 1 }} />
            <Skeleton variant="rounded" height={16} />
        </NotDeliveredCard>
    </ContainerCards>
);

export default LogsCardsSkeleton;